export { default as BlogFooterQuery } from './BlogFooterQuery';